import { render, staticRenderFns } from "./newCategory.vue?vue&type=template&id=5db9978c&"
import script from "./newCategory.vue?vue&type=script&lang=js&"
export * from "./newCategory.vue?vue&type=script&lang=js&"
import style0 from "./newCategory.vue?vue&type=style&index=0&id=5db9978c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports